<template>
	<!-- 书单 -->
	<div class="booksdBox">
		<!-- v-if="my_collect.length" -->
		<div class="modebook">
			<!-- 我收藏的书单 -->
			<!-- 排序方式 -->
			<div class="solt">
				<div @click="toggle('my_collect')">
					<span v-model="queryTitle">{{queryTitle}}</span>
					<img :class="selectItem == true ? 'up' : ''" src="../../assets/img/downarr.png" alt="" />
				</div>
			</div>
			<!-- 列表数据 -->
			<div v-show="selectItem">
				<div class="blockBox">
					<!--  -->
					<div class="blockLeft" v-if="my_collect.length" v-for="(item,index) in my_collect" :key="item.id" @touchstart="gotouchstart(item.collect_id,'sc')"
					 @touchmove="gotouchmove" @touchend="gotouchend(item.collect_id,'sc')" @click="bookInfoFn(item.collect_id)">
						<div class="book_Img">
							<!-- 一本时 显示两个默认图片 -->
							<div v-if="item.cover_image.length == 1">
								<div class="book_Img1" v-for="(i,cover_imageItem) in item.cover_image" v-if="cover_imageItem >= 3 ? false : true">
									<img :src="$api.$BASE_URL_img +i.cover_image" alt="" />
								</div>
								<div class="book_Img1">
									<img src="../../assets/img/bookName.png" alt="" />
								</div>
								<div class="book_Img1">
									<img src="../../assets/img/bookName.png" alt="" />
								</div>
							</div>
							<!-- 两本时 显示一个默认图片 -->
							<div v-if="item.cover_image.length == 2">
								<div class="book_Img1" v-for="(i,cover_imageItem) in item.cover_image" v-if="cover_imageItem >= 3 ? false : true">
									<img :src="$api.$BASE_URL_img +i.cover_image" alt="" />
								</div>
								<div class="book_Img1">
									<img src="../../assets/img/bookName.png" alt="" />
								</div>
							</div>
							<!-- 大于等于三本时 显示实时数据 -->
							<div v-if="item.cover_image.length >= 3">
								<div class="book_Img1" v-for="(i,cover_imageItem) in item.cover_image" v-if="cover_imageItem >= 3 ? false : true">
									<img :src="$api.$BASE_URL_img +i.cover_image" alt="" />
								</div>
							</div>
						</div>
						<div class="blockBookInfo">
							<p class="bookName">{{item.collect_name}}</p>
							<div class="auther"><span>{{item.maker}}</span></div>
							<p class="tjnum"><span>{{item.cover_image.length}}本</span><span>{{item.collect_count}}人收藏</span></p>
							<!-- <div class="del" v-show="isDel" @click="delBooks(item.id)">
								<img src="../../assets/img/dele.png" alt="">
							</div> -->
						</div>
					</div>
				</div>
				<div v-if="!my_collect.length" class="zwsjToast">
					<img src="../../assets/img/data_null.png" alt="">
				</div>
			</div>
		</div>
		<!-- v-if="my_make.length" -->
		<div class="modebook">
			<!-- 我制作的书单 -->
			<div class="solt">
				<div @click="toggle('my_make')">
					<span v-model="modeQueryTitle">{{modeQueryTitle}}</span>
					<img :class="modeSelectItem == true ? 'up' : ''" src="../../assets/img/downarr.png" alt="" />
				</div>
			</div>
			<!-- 列表数据 -->
			<div v-show="modeSelectItem">
				<div class="blockBox">
					<!-- @click="bookInfoFn(item.id)" -->
					<div class="blockLeft" v-for="(item,index) in my_make" :key="item.id" @touchstart.stop="gotouchstart(item.id,'mode')"
					 @touchmove.stop="gotouchmove" @touchend.stop="gotouchend(item.id,'mode')" @click="bookInfoFn(item.id)">
						<div class="book_Img">
							<!-- 一本时 显示两个默认图片 -->
							<div v-if="item.cover_image.length == 1">
								<div class="book_Img1" v-for="(i,cover_imageItem) in item.cover_image" v-if="cover_imageItem >= 3 ? false : true">
									<img :src="$api.$BASE_URL_img +i.cover_image" alt="" />
								</div>
								<div class="book_Img1">
									<img src="../../assets/img/bookName.png" alt="" />
								</div>
								<div class="book_Img1">
									<img src="../../assets/img/bookName.png" alt="" />
								</div>
							</div>
							<!-- 两本时 显示一个默认图片 -->
							<div v-if="item.cover_image.length == 2">
								<div class="book_Img1" v-for="(i,cover_imageItem) in item.cover_image" v-if="cover_imageItem >= 3 ? false : true">
									<img :src="$api.$BASE_URL_img +i.cover_image" alt="" />
								</div>
								<div class="book_Img1">
									<img src="../../assets/img/bookName.png" alt="" />
								</div>
							</div>
							<!-- 大于等于三本时 显示实时数据 -->
							<div v-if="item.cover_image.length >= 3">
								<div class="book_Img1" v-for="(i,cover_imageItem) in item.cover_image" v-if="cover_imageItem >= 3 ? false : true">
									<img :src="$api.$BASE_URL_img +i.cover_image" alt="" />
								</div>
							</div>

						</div>
						<div class="blockBookInfo">
							<p class="bookName">{{item.name}}</p>
							<div class="auther"><span>{{item.maker}}</span></div>
							<p class="tjnum"><span>{{item.cover_image.length}}本</span><span>{{item.collect_count}}人收藏</span></p>
							<div class="del" v-show="isDel" @click="delBooks(item.id)">
								<img src="../../assets/img/dele.png" alt="">
							</div>
						</div>
					</div>
					<div v-if="my_make.length == 0 ? true : false" class="zwsjToast">
						<img src="../../assets/img/data_null.png" alt="">
					</div>
				</div>
			</div>
		</div>
		
		<!-- deleShow -->
		<div class="luntantost" v-show="deleShow">
			<!-- <img src="../../assets/img/cat.png" alt=""> -->
			<div class="luntantostbgc">
				<div @click="delBooks" class="active">
					<span v-if="cateTxt == 'sc'">取消收藏</span>
					<span v-else>删除</span>
					</div>
			</div>
		</div>
		<div class='mask' v-show="deleShow" @click="hideTost01"></div>
	</div>
</template>

<script>
	import {
		Toast,
		Dialog
	} from 'vant';
	export default {
		data() {
			return {
				queryIndex: 0,
				selectItem: true,
				queryTitle: '我收藏的书单',
				modequeryIndex: 0,
				modeQueryTitle: '我制作的书单',
				modeSelectItem: true,
				bookInfoList: [{
						bookName: '谁动了我的账号',
						auther: "啊金宝",
						bookNum: '19',
						txtNum: "1089",
						id: 0,
					},
					{
						bookName: '谁动了我的账号',
						auther: "啊金宝",
						bookNum: '18',
						txtNum: "1089",
						id: 1,
					},
				],
				selectItemList: [{
						txt: '按收藏数'
					},
					{
						txt: '按积分'
					},
					{
						txt: '按更新时间'
					},
					{
						txt: '按发表时间'
					},
					{
						txt: '按字数'
					},
				],
				modeselectItemList: [{
						txt: '我制作的书单'
					},
					{
						txt: '按积分'
					},
					{
						txt: '按更新时间'
					},
					{
						txt: '按发表时间'
					},
					{
						txt: '按字数'
					},
				],
				my_collect: [], //我收藏的书单
				my_make: [], //我制作的书单
				isDel: false, //删除
				deleShow: false,
				clearHfId: '',
				cateTxt:'',
			}
		},
		created() {
			this.get_books_list();
		},
		methods: {
			toggle(a) {
				console.log(a);
				if (a == 'my_collect') {
					this.selectItem = !this.selectItem
				} else if (a == 'my_make') {
					this.modeSelectItem = !this.modeSelectItem
				}

			},
			// query_select(index, txt) {
			// 	console.log(index)
			// 	this.queryIndex = index
			// 	this.queryTitle = txt
			// 	this.selectItem = !this.selectItem
			// },
			// modeToggle() {
			// 	this.modeSelectItem = !this.modeSelectItem
			// },
			// modequery_select(index, txt) {
			// 	this.modequeryIndex = index
			// 	this.modeQueryTitle = txt
			// 	this.modeSelectItem = !this.modeSelectItem
			// },
			gotouchstart(id,cateTxt) {
				this.clearHfId = id;
				this.cateTxt = cateTxt;
				let that = this;
				clearTimeout(that.timeOutEvent); //清除定时器
				that.timeOutEvent = setTimeout(function() {
					//执行长按要执行的内容，
					that.deleShow = true;
				}, 800); //这里设置定时
			},
			//手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
			gotouchend(id) {
				clearTimeout(this.timeOutEvent);
				if (this.timeOutEvent != 0) {
					//这里写要执行的内容（尤如onclick事件）
					// that.tostShow = true;
					// this.bookInfoFn(id)
				}
			},
			//如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按 
			gotouchmove() {
				clearTimeout(this.timeOutEvent); //清除定时器
				this.timeOutEvent = 0;
			},
			// 删除书单
			delBooks() {
				var _t = this;
				var txt;
				if(this.cateTxt == 'sc'){
					txt = '取消收藏' 
				}else{
					txt = '删除该书单' 
				}
				Dialog.confirm({
						// title: '',
						message: txt,
					})
					.then(() => {
						if(this.cateTxt == 'sc'){
							_t.$axios.post(`${_t.$api.book_list_collect}?list_id=${_t.clearHfId}`).then(res => {
								if (res.data.code == 1) {
									_t.get_books_list();
									_t.isDel = false;
									_t.$emit("queryIndexbind", 0)
								}
							
								_t.$toast(res.data.msg);
							})
						}else if(this.cateTxt == 'mode'){
							_t.$axios.post(`${_t.$api.del_books_list}?list_id=${_t.clearHfId}`).then(res => {
								if (res.data.code == 1) {
									_t.get_books_list();
									_t.isDel = false;
									_t.$emit("queryIndexbind", 0)
								}
							
								_t.$toast(res.data.msg);
							})
						}
						
						this.deleShow = false;
					})
					.catch(() => {
						// on cancel
					});
			},
			bookInfoFn(id) {
				this.$router.push({
					path: "/bookdyinfo",
					query: {
						id: id
					}
				})
			},
			get_books_list() {
				this.$axios.post(this.$api.books_list).then(res => {
					if (res.data.data != null) {
						this.my_collect = res.data.data.my_collect;
						console.log(this.my_collect, 'my_collect')
						this.my_make = res.data.data.my_make;
					} else {
						Toast(res.data.msg)
					}

				})
			},
			showDelbtn() {
				this.isDel = true;
			},
			// delBooks(id) { //删除书单
			// 	var _t = this;
			// 	_t.$axios.post(`${_t.$api.del_books_list}?list_id=${id}`).then(res => {
			// 		if (res.data.code == 1) {
			// 			_t.get_books_list();
			// 			_t.isDel = false;
			// 			_t.$emit("queryIndexbind", 0)
			// 		}

			// 		_t.$toast(res.data.msg);
			// 	})
			// },
			hideTost01() {
				this.deleShow = false;
			},
		},

	}
</script>

<style lang="less" scoped>
	.booksdBox {
		margin-bottom: 10px;
		height: calc(100vh - 50px);
		/*no*/
		overflow-x: hidden;
		background-color: #fff;

		.zwsjToast {
			text-align: center;
			margin-top: 10%;

			img {
				width: 160px;
			}
		}

		.modebook {
			border-bottom: 10px solid #f0f0f0;
			//排序方式
			.solt {
				background-color: #fff;
				position: relative;
				padding: 0 16px;
				padding-top: 24px;
				padding-bottom: 14px;
				div {
					line-height: 60px;

					span {
						font-size: 30px;
						/*px*/
						font-weight: bold;
						color: #000;
					}

					img {
						margin-left: 10px;
						width: 20px;
					}

					img.up {
						transform: rotate(180deg);
					}

				}

				ul {
					position: absolute;
					top: 80px;
					left: 100px;
					background-color: #fff;
					z-index: 100;
					padding: 0 20px;

					// box-shadow: 0 0 5px 0 rgba(0,0,0,.3);/*no*/
					li {
						line-height: 50px;
						border-bottom: 1px solid #f0f0f0;

						span {
							font-size: 28px;
							/*px*/
						}

						img {
							margin-left: 10px;
							width: 20px;
							height: 20px;
						}
					}

					.select_item {
						width: 100px;
						border-radius: 20px;
					}

					.activeQuery {
						color: #ff4081;
						border-bottom: 4px solid #f0f0f0;
						/*no*/
					}
				}
			}

			//列表数据
			.blockBox {
				overflow: hidden;
				position: relative;
				padding: 0 16px;
				background-color: #fff;

				.blockLeft {
					display: flex;
					background-color: #fff;
					padding: 20px 0px;
					padding-bottom: 20px;
					border-bottom: 1px solid #f0f0f0;

					/*no*/
					.book_Img {
						width: 220px;
						height: 240px;
						// float: left;
						position: relative;

						.book_Img1:nth-child(3) {
							img {
								max-width: 85px;
								height: 120px;
								display: block;
								position: absolute;
								left: 130px;
								top: 50%;
								transform: translateY(-50%);
								-webkit-transform: translatez(-55%);
								-moz-transform: translatez(-55%);
								box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, .3);
								/*no*/
								z-index: 1;
							}
						}

						.book_Img1:nth-child(2) {
							img {
								width: 100px;
								height: 150px;
								display: block;
								position: absolute;
								left: 80px;
								top: 50%;
								transform: translateY(-50%);
								-webkit-transform: translatez(-50%);
								-moz-transform: translatez(-50%);
								box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, .3);
								/*no*/
								z-index: 2;
							}
						}

						.book_Img1:nth-child(1) {

							img {
								width: 136px;
								height: 200px;
								display: block;
								position: absolute;
								left: 10px;
								top: 50%;
								transform: translateY(-50%);
								-webkit-transform: translatez(-20%);
								-moz-transform: translatez(-20%);
								box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, .3);
								/*no*/
								z-index: 3;
							}
						}
					}

					.blockBookInfo {
						margin-left: 10px;
						flex: 1;
						font-size: 26px;
						/*px*/
						line-height: 60px;
						padding: 20px 0;
						position: relative;
						z-index: 2;

						.del {
							position: absolute;
							top: 20px;
							right: 0px;
							width: 55px;
							height: 55px;

							img {
								width: 100%;
								height: 100%;
							}
						}

						.bookName {
							font-size: 30px;
							/*px*/
							font-weight: 400;
							color: #000000;
							width: 80%;
							overflow: hidden;
							text-overflow: ellipsis;
							word-break: break-word;
							line-clamp: 1;
							-webkit-line-clamp: 1;
							display: -webkit-box;
							-webkit-box-orient: vertical;
						}

						.auther {
							color: #000;
							font-size: 26px;
							/*px*/
							opacity: 0.6;
						}

						.tjnum {
							span {
								margin-right: 8px;
								color: #000;
								font-size: 24px;
								/*px*/
								opacity: 0.4;
							}

							// .wanjie {
							//color: #ff0000;
							// }

							//.txtGreen {
							//color: #5ca615;
							//}

						}

						.bookType,
						.introduction {
							padding-top: 20px;
							color: #a3a3a3;
						}

						.introduction {
							width: 60vw;
							padding-top: 15px;

							p {
								overflow: hidden;
								white-space: nowrap;
								text-overflow: ellipsis;
							}
						}

						.book_button {
							margin-top: 25px;

							button {
								border: 0;
								outline: none;
								border: 1px solid #fec6d5;
								/*no*/
								border-radius: 28px;
								padding: 0 20px;
								line-height: 40px;
								/*px*/
								background-color: #fff8fa;
								color: #fa7298;
								margin-right: 20px;
								font-size: 26px;
								/*px*/
							}

							.active {
								background-color: #fa7298;
								color: #ffffff;
							}
						}
					}
				}

			}
		}

		//弹窗
		.luntantost {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100vw;
			// height: 454px;
			background: url(../../assets/img/pltost.png) no-repeat;
			background-size: 100%;
			z-index: 120;

			img {
				position: absolute;
				bottom: 40px;
				left: 0;
				width: 100%;
			}

			.luntantostbgc {
				margin-top: 124px;
				z-index: 10000 !important;
				background: url(../../assets/img/dog.png) no-repeat #fff;
				background-size: 100%;
				background-position: 0px 50%;

				div {
					line-height: 120px;
					text-align: center;
					color: #737373;
					font-size: 30px;
					/*px*/
					z-index: 1000 !important;
				}

				div.active {
					color: #ff4081;
				}

			}

		}

		.mask {
			position: fixed;
			top: -160px;
			left: 0;
			width: 100vw;
			height: 100vh;
			background-color: rgba(0, 0, 0, .3);
			z-index: 100;
		}
	}
</style>
